<template>
  <div>
    <div class="row no-gutters justify-center align-center lighten-4 pa-2">
      <div class="col-4 text-left grey--text text--darken-4">{{keyComputed}}</div>
      <div class="col-4 text-left grey--text text--darken-2">
        <div v-if="!editOn" class="pa-2">{{valueComputed}}</div>
        <v-text-field
          v-if="editOn"
          dense
          outlined
          @keyup.13.exact="update"
          v-model="value"
          hide-details
          class="pa-0"
        ></v-text-field>
      </div>
      <div class="col-4">
        <v-btn color="primary" v-if="!editOn" @click="editOn = true" text small>
          <v-icon small>edit</v-icon>
        </v-btn>
        <v-btn
          class="primary ma-1"
          small
          v-if="editOn"
          @click="update"
          :disabled="!valueUpdated"
          :loading="loading"
        >
          <v-icon left small>save</v-icon>save
        </v-btn>
        <v-btn color="primary ma-1" small v-if="editOn" @click="editOn = false" text>
          <v-icon>clear</v-icon>
        </v-btn>
      </div>
    </div>
    <div class="bottom-border"></div>
  </div>
</template>

<script>
import _ from "lodash";
import snackbarMixin from "../mixins/snackbar";
import axios from "../api/axios";

export default {
  name: "ARecordEditor",
  mixins: [snackbarMixin],
  props: ["item", "model"],
  data() {
    return {
      loading: false,
      editOn: false,
      value: ""
    };
  },
  computed: {
    valueUpdated: function() {
      return this.item.value != this.value;
    },  
    keyComputed: function() {
      return this.item.name
    },
    valueComputed: function() {
      return this.item.value == ""? "-": this.item.value
    }
  },
  watch: {
    editOn: function() {
      if (this.editOn) this.value = this.item.value;
    }
  },
  methods: {
    async update() {
      if (!this.valueUpdated) {
        this.snackbarWarn("No changes to update");
        return;
      }
      try {
        this.loading = true;
        const res = await axios.put(this.model + "/" + this.item.id, {
          value: this.value
        });
        if (res.data.ok) {
          this.$emit("changed");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.editOn = false;
        this.loading = false;
      }
    }
  }
};
</script>